import useLocalStorageJson from '@postinumero/storage/lib/useLocalStorageJson.js';
import jwt_decode from 'jwt-decode';
import React, { useEffect, useState } from 'react';
import withLocalStorageKeyContext, { useLocalStorageKey, } from './withLocalStorageKeyContext.js';
export const initOptions = {
    checkLoginIframe: false,
    pkceMethod: 'S256',
    onLoad: null,
};
export default function withPageRefreshSupport(Provider) {
    return withLocalStorageKeyContext(function ReactKeycloakProvider(props) {
        const { onTokens, ...other } = props;
        const [initialized, setInitialized] = useState(false);
        const [storedTokens, setStoredTokens] = useLocalStorageJson(useLocalStorageKey());
        const sub = (storedTokens === null || storedTokens === void 0 ? void 0 : storedTokens.token) &&
            jwt_decode(storedTokens.token).sub;
        // To avoid infinite login cycle, especially when multiple tabs are open,
        // don't use stored tokens directly.
        const [tokens, setTokens] = useState(storedTokens);
        useEffect(() => {
            if (initialized) {
                setTokens(sub ? storedTokens : null);
            }
            // We want to update the tokens only if initialized and when the subject
            // changes.
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [sub]);
        return (React.createElement(Provider, { initOptions: {
                ...initOptions,
                ...tokens,
                ...props.initOptions,
            }, onTokens: async (tokens) => {
                const { refreshToken, token } = tokens;
                setStoredTokens({ token, refreshToken });
                await (onTokens === null || onTokens === void 0 ? void 0 : onTokens(tokens));
                setInitialized(true);
            }, ...other }, initialized && other.children));
    });
}
//# sourceMappingURL=index.js.map